import { MonetaryAmount } from "../monetary-amount";
import CompanyInterface from "./types";

interface BenefitConfig {
  renting: boolean;
  "life-insurance": boolean;
  wellness: string[];
}

interface Modality {
  modalityId: string;
  modalityName: string;
  modalityFee: MonetaryAmount;
}

export default class Company {
  id: string;

  name: string;

  countryISO2Code: string;

  modalities: Modality[];

  extraBenefits: BenefitConfig;

  constructor({
    id = "",
    name = "",
    countryISO2Code = "ES",
    modalities = [],
    extraBenefits = { renting: false, "life-insurance": false, wellness: [] },
  }: {
    id?: string;
    name?: string;
    countryISO2Code?: string;
    modalities?: Modality[];
    extraBenefits?: BenefitConfig;
  }) {
    this.id = id;
    this.name = name;
    this.countryISO2Code = countryISO2Code;
    this.modalities = modalities;
    this.extraBenefits = extraBenefits;
  }

  modCompanyId = ({ id }: { id: string }): CompanyInterface =>
    new Company({ ...this, id });

  modEmployeeName = ({
    name = this.name,
  }: {
    name: string;
  }): CompanyInterface => new Company({ ...this, name });
}
